export const identity = {
    yourIdentity: {
        revealIdentity: 'Whistleblowers identity',
        yesRevealIdentity: 'Yes, I want to reveal my identity',
        noDontRevealIdentity: 'No, I want to remain anonymous',
    }
};
